import { getNamedDates } from 'services/utils';

/**
 * Quais abas a área interna dos desafios exibe, dado o ciclo e o perfil.
 *
 * A partir do 2S2026 sobra só Colaboração: a área encerrou os desafios de funcionários, os da
 * liderança e as campanhas. O corte é por data e não por título do ciclo, igual ao do bloco de
 * ações do dashboard — os dois refletem a mesma decisão e precisam sumir juntos, senão a home
 * deixa de anunciar um desafio que a aba ainda abre.
 *
 * As condições saíram do JSX porque a barra precisa saber quantas abas sobraram antes de se
 * desenhar: com zero abas ela vira um vão em branco no layout.
 */
export type ChallengeTab = 'jogador' | 'gestor' | 'arraia' | 'campanhas' | 'colaboracao';

export type ChallengeTabsInput = {
  /** `date_start` do ciclo ativo na tela. Ausente enquanto o ciclo não carregou. */
  cycleStartDate?: number;
  /** Regra do gestor (`isGestorSemCadastro`). */
  isGestor?: boolean;
  /** `has_hybrid_on_team` — pré-requisito da aba de Colaboração. */
  hasHybridOnTeam?: boolean;
};

export function visibleChallengeTabs(input: ChallengeTabsInput): ChallengeTab[] {
  const { cycleStartDate, isGestor, hasHybridOnTeam } = input;

  const dates = getNamedDates();
  const tabs: ChallengeTab[] = [];

  const hasCycle = typeof cycleStartDate === 'number';
  const anteriorAo2S2026 = hasCycle && (cycleStartDate as number) < dates.ciclo_2S2026;

  if (anteriorAo2S2026) tabs.push('jogador');

  if (isGestor && anteriorAo2S2026) tabs.push('gestor');

  if (hasCycle && cycleStartDate === dates.ciclo_1S2025) tabs.push('arraia');

  if (hasCycle && (cycleStartDate as number) >= dates.ciclo_2S2025 && anteriorAo2S2026) {
    tabs.push('campanhas');
  }

  if (hasHybridOnTeam) tabs.push('colaboracao');

  return tabs;
}
